import * as angular from 'angular';
import { IComponentOptions } from 'angular';

namespace nv.SchoolMetricsModule {
  'use strict';

  const masterProgramTableFilters: IComponentOptions = {
    bindings: {
      masterProgram: '<',
      subjectAreas: '<',
      teachers: '=',
      courseFilter: '=',
      updateCourseFilter: '@',
      filterCourseCodeWithSection: '=',
    },
    controller: 'MasterProgramTableFiltersCtrl',
    template: require('./master-program-table-filters.html'),
  };

  angular.module('nv.SchoolMetricsModule').component('masterProgramTableFilters', masterProgramTableFilters);
}
